// extracted by mini-css-extract-plugin
export default {"errorWrapper":"MqfDVN9KlTmIte3FyRJX"};